export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmYUtfBBc4AMP6lQ.e012f6c3.woff2";